import { render, staticRenderFns } from "./SelectModal.vue?vue&type=template&id=53e4a7ec&"
import script from "./SelectModal.vue?vue&type=script&lang=js&"
export * from "./SelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('53e4a7ec', component.options)
    } else {
      api.reload('53e4a7ec', component.options)
    }
    module.hot.accept("./SelectModal.vue?vue&type=template&id=53e4a7ec&", function () {
      api.rerender('53e4a7ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/components/select/SelectModal.vue"
export default component.exports